export const EAN_MAX_LENGTH: number = 40;
export const MAX_SEARCH_EAN_RESULT: number = 200;
